<app-custom-icons 
    *ngIf="interaction?.interactionType !== 'interactions'"
    [icon]="interaction?.nodeType ? interaction?.nodeType +'.svg' : interaction?.interactionType ? interaction?.interactionType +'.svg' : 'interactions.svg'"
    [color]="'#e97e97'" [size]="'14px'" class="d-inline-block mr-2"></app-custom-icons>
<span *ngIf="interaction?.interactionType !== 'interactions'">{{interaction?.title}}</span>